import { Fragment } from 'react';
import { CellContent } from '@/modules/vip/ComparisonSection/components/CellContent';
import {
  ScLabelCell,
  ScSectionTitle,
  ScValueCell,
} from '@/modules/vip/ComparisonSection/components/ComparisonSlider/styled';
import { ScSectionSpacer } from '@/modules/vip/ComparisonSection/components/ComparisonTable/styled';
import type { IComparisonUISection } from '@/modules/vip/ComparisonSection/types';

export const SectionGroup = ({
  colIds,
  section,
}: {
  colIds: number[];
  section: IComparisonUISection;
}) => (
  <>
    <ScSectionTitle>{section.title}</ScSectionTitle>
    {colIds.map((colId) => (
      <ScSectionSpacer key={colId} />
    ))}
    {section.rows.map(({ id, label, cells }) => (
      <Fragment key={id}>
        <ScLabelCell>{label}</ScLabelCell>
        {cells.map((cell, i) => (
          <ScValueCell key={colIds[i]}>
            <CellContent cell={cell} />
          </ScValueCell>
        ))}
      </Fragment>
    ))}
  </>
);
